export type Dashboard = {
  id: "live-data" | "historical-data";
  name: string;
};

export const dashboards: Dashboard[] = [
  { id: "live-data", name: "Live data" },
  { id: "historical-data", name: "Historiske data" },
];
